

<div :class="['container-fluid bg-white p-0', !liveness_photo ? 'vh-100' : 'min-vh-100']">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="OCR Liveness Verification" />

    <!-- OCR Document Reader -->
    <OcrDocumentReader :photo="liveness_photo" v-if="liveness_photo" />

    <!-- Facial Biometrics -->
    <FacialBiometricsComponent v-else @set-liveness-photo="set_liveness_photo" />
  </div>